function initHeaderCtaNotice() {
  const notice = document.querySelector(".header-cta-notice");
  if (!notice) return;

  // Desktop only — matches the header breakpoint where the nav-bar CTA is
  // visible (below this the standalone .btn-header-signin links directly).
  const isDesktop = () => window.matchMedia("(min-width: 1400px)").matches;

  document.addEventListener("click", (e) => {
    // ignore modified clicks so users can still force-open in a new tab, etc.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const trigger = e.target.closest("[data-header-cta]");
    if (!trigger) return;

    // The standalone header button opens the popup at any width; the in-menu
    // nav link stays desktop-only.
    const isSigninBtn = trigger.classList.contains("btn-header-signin");
    if (!isSigninBtn && !isDesktop()) return;

    e.preventDefault();
    notice.showModal();
  });

  notice.querySelector(".header-cta-notice-close")?.addEventListener("click", () => notice.close());

  // light-dismiss when clicking the backdrop
  notice.addEventListener("click", (e) => {
    if (e.target === notice) notice.close();
  });
}

// theme.js is a footer script that can execute before the dialog markup
// (hooked later in wp_footer) is parsed, so wait for the DOM to be ready.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeaderCtaNotice);
} else {
  initHeaderCtaNotice();
}
